import { render } from "./ManagementPage.vue?vue&type=template&id=1a22e54f&scoped=true&lang=pug"
import script from "./ManagementPage.vue?vue&type=script&lang=js"
export * from "./ManagementPage.vue?vue&type=script&lang=js"

import "./ManagementPage.vue?vue&type=style&index=0&id=1a22e54f&lang=scss&scoped=true"
import "./ManagementPage.vue?vue&type=style&index=1&id=1a22e54f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a22e54f"]])

export default __exports__